import { Monitor } from "lucide-react";
import { useState } from "react";
import { Outlet } from "react-router";
import { track } from "@/shared/lib/track";
import { PortalContainer, setViewMode, useIsWide, useViewMode } from "@/shared/lib/view-mode";

/** Mobilnézet nagy képernyőn (design-rendszer 6., „Mobilnézet”; vászon: M2 telefonkeret):
 *  bekapcsolva és széles ablakban az oldalak egy középre igazított, telefon méretű keretben
 *  futnak, akármilyen széles a képernyő; jobb felül az „Asztali nézet” gomb kapcsol vissza.
 *  Keskeny ablakban (telefonon) nincs keret — az oldal amúgy is telefonos.
 *
 *  A keretben a töréspontos stílusok nem élnek (theme.css, `.view-frame`); a `transform`
 *  miatt a keret a `fixed` elemek (alsó sáv, panelek) befoglalója, így azok a kerethez
 *  igazodnak; a görgetés a belső rétegen történik, a panelek portálja a keret. Az admin
 *  nincs alatta (router.tsx). */
export function ViewFrame() {
  const mode = useViewMode();
  const wide = useIsWide();
  const [screen, setScreen] = useState<HTMLDivElement | null>(null);

  if (mode !== "mobile" || !wide) return <Outlet />;

  return (
    <div className="flex min-h-dvh items-center justify-center bg-gray p-6">
      <button
        type="button"
        onClick={() => {
          track("core.view_mode", "auto");
          setViewMode("auto");
        }}
        className="fixed right-6 top-6 z-10 flex h-10 items-center gap-2 rounded-full border border-line bg-white px-4 text-[13px] font-semibold text-ink-soft shadow-segment hover:bg-paper"
      >
        <Monitor size={16} strokeWidth={1.8} className="text-muted" />
        Asztali nézet
      </button>
      <div className="rounded-[54px] bg-ink p-[15px] shadow-frame">
        <div
          ref={setScreen}
          className="view-frame h-[min(calc(100dvh-80px),890px)] w-[390px] overflow-hidden rounded-[40px] bg-white [transform:translateZ(0)]"
        >
          <div className="h-full overflow-y-auto overscroll-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            <PortalContainer.Provider value={screen}>
              <Outlet />
            </PortalContainer.Provider>
          </div>
        </div>
      </div>
    </div>
  );
}
